import React, { useState, useEffect } from "react";
//import TituloCard from "../../atoms/titles/Titulo";


import Logo from "../../../resources/img/icono-publicaciones.png";
import ConsultaIRPFHabi from "../modals/consultaIRPFHabi/ConsultaIRPFHabi";

const IRPFHabilitadoNuevo = () => {
  const [show, setShow] = useState({ nomina: false, mensaje: false });

  const handleShow = (e) => {
    setShow(e);
  };
  const handleClose = (e) => {
    setShow(false);
  };
  useEffect(() => { }, []);

  return (
    <section className="temas">
      <div className="card-caja-mini temas card m-4 h-auto"
        onClick={() => handleShow({ irpf: true })}
        tabIndex={0}
        title="IRPF Habilitado"
        aria-label="IRPF Habilitado"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            handleShow({ irpf: true })
          }
        }}
        >

        <div className="tituloAccesibilidad d-flex align-items-center">
          <img

            alt="IRPF"
            src={Logo}
          />
          <h3 className="tituloAccesibilidad ms-2"> Certificado IRPF por las habilitaciones</h3>
        </div>

        <span className="mx-4 card-text bot-text">Ver Certificado IRPF por las habilitaciones</span>

      </div>
      {show.irpf ? (
        <ConsultaIRPFHabi show={show} handleClose={handleClose}></ConsultaIRPFHabi>
      ) : null}
    </section>


  );
};
export default IRPFHabilitadoNuevo;
